require("./navigation-v2.scss");
require("./navigation.js");